import cx from 'classnames';

import { ConditionalField } from 'Components/ConditionalField';
import { applyTestIdData } from 'Utilities/helpers';
import useFeatureToggle from 'Utilities/hooks/useFeatureToggle';

import type { SpecSectionField } from './SpecSection.types';

import styles from './SpecSectionItem.module.scss';

interface SpecSectionItemProps<T> extends SpecSectionField<T> {
	data: T;
	isPrint?: boolean;
}

export const SpecSectionItem = <T,>({
	data,
	featureToggle,
	fieldName,
	isPrint,
	isVisible,
	label,
	value,
}: SpecSectionItemProps<T>): JSX.Element => {
	const isFeatureEnabled = useFeatureToggle(featureToggle);
	const isComponentVisible = isVisible({ isFeatureEnabled, value: data });

	return (
		<ConditionalField isVisible={isComponentVisible}>
			<div className={cx(styles.field, { [styles.print]: isPrint })}>
				<div className={styles.label} {...applyTestIdData(`field-label-${String(fieldName)}`)}>
					{label(data)}
				</div>
				<div className={styles.value} {...applyTestIdData(`field-value-${String(fieldName)}`)}>
					{value(data)}
				</div>
			</div>
		</ConditionalField>
	);
};
